<template>
  <div class="wrapper">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <el-table
        :data="formData.config_data"
        style="width: 100%"
        @row-click="handleRowClick"
      >
        <el-table-column
          prop="title"
          label="标题"
          width="450"
        >
          <template #default="{ row }">
            <el-input
              v-model="row.title"
              placeholder="请输入标题"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="icon"
          label="icon"
          width="200"
        >
            <template #default="{ row }">
                <el-input
                    v-model="row.icon"
                    placeholder="请勿修改"
                    readonly
                ></el-input>
            </template>
        </el-table-column>
        <el-table-column
          prop="dsc"
          label="描述"
        >
          <template #default="{ row }">
            <el-input type="textarea"
              v-model="row.dsc"
              placeholder="请输入描述"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-form-item label="">
        <el-button
          type="primary"
          size="small"
          @click="save"
        >保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getSettingConfigApi, settingConfigApi } from './api'

export default {
  name: 'AboutMe',
  data () {
    return {
      formData: {
        key: 'about_me',
        config_data: [
          {
            dsc: '',
            icon: '',
            title: ''
          } // 初始化一个空项
        ]
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        dsc: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      }
    }
  },

  mounted () {
    this.getDetail()
  },

  methods: {
    cancel () {
      this.getDetail()
    },
    handleRowClick (row) {
      // 选中某一行时，聚焦输入框
      const input = document.querySelector(`[v-model="${row.title}"]`)
      if (input) {
        input.focus()
      }
    },
    addItem () {
      this.formData.config_data.push({
            dsc: '',
            icon: '',
            title: '', })
    },
    removeItem (index) {
      this.formData.config_data.splice(index, 1)
    },
    async getDetail () {
      const res = await getSettingConfigApi(this.formData.key)
      if (res) {
        this.formData = res
      }
    },
    save () {
      this.formData.config_data = this.formData.config_data.map((item, index) => {
        return {
          ...item,
          index
        }
      })
      settingConfigApi(this.formData).then(() => {
        this.$message.success('保存成功')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
